export default __webpack_public_path__ + "static/media/ic-topSell.54ef965d.png";